import React from 'react';
import PropTypes from 'prop-types';
import LoginController from '../controllers/LoginController';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import LoadingButton from '../components/LoadingButton';
import AvatarPage from './AvatarPage';

const styles = (theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
    }
});

/**
 * Página de login. Realiza a autenticação do usuário e redireciona para o menu principal
 */
class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        //Controlares
        this.loginController = new LoginController();
        //Estado inicial
        this.state = {
            email: '',
            mensagem: '',
            carregando: false
        };
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Executa quando o form é submetido.
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleSubmit(event) {
        //Impede a propagação do evento
        event.preventDefault();
        this.setState({ carregando: true });
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        state.carregando = false;
        //Executa o login
        const result = await this.loginController.recuperarSenha(this.state.email);
        if (!result.sucesso) {
            //Caso tenha ocorrido um erro durante o login, define a mensagem
            state.mensagem = result.mensagem;
        } else {
            //Caso contrário, exibe a mensagem que o e-mail foi enviado
            state.mensagem = 'Foi enviado um e-mail para o endereço indicado com as instruções para cadastrar uma nova senha';
        }
        //Atualiza o estado
        this.setState(state);
    }

    render() {
        const { classes } = this.props;
        const { email, mensagem } = this.state;
        return (
            <AvatarPage>
                <Typography component="h1" variant="h5">Informe seu e-email para recuperar a senha</Typography>
                <form onSubmit={this.handleSubmit} >
                    <Grid container>
                        <Grid item xs={12} >
                            <TextField 
                                name="email" 
                                label="E-mail" 
                                type="text" 
                                placeholder="E-mail" 
                                required
                                variant="outlined" 
                                margin="normal" 
                                fullWidth 
                                value={email} 
                                helperText="No momento apenas a recuperação por e-mail está disponível"
                                onChange={this.handleChange} 
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <Typography id="error-message">{mensagem}</Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <LoadingButton 
                                fullWidth 
                                variant="contained" 
                                color="primary" 
                                type="submit"
                                className={classes.submit} 
                                loading={this.state.carregando}
                            >
                                Enviar e-mail
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={12} >
                            <Button 
                                variant="text" 
                                color="default" 
                                component={Link}
                                to="/login"
                            >
                                Fazer login
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </AvatarPage>
        );
    }
}

LoginPage.propTypes = {
    /** Classes CSS utilizadas pela página */
    classes: PropTypes.shape({
        paper: PropTypes.any,
        avatar: PropTypes.any,
        submit: PropTypes.any
    })
};

export default withStyles(styles)(LoginPage);